<template>
  <div>
    <van-list v-model="loading" :finished="finished" @load="onLoad">

        <van-cell-group>
          <div class="van-panel__header van-hairline--bottom" v-for="(item,index) in list" :key="item.id" @click="onShow(item.id,index)">
            <div class="van-panel__title">姓名: {{ item.name }}   <van-tag v-if="item.is_edit" type="success" style="float: right">已跟进</van-tag></div>
            <span class="van-panel__desc">
              <van-row gutter="4">
                <van-col span="10">电话: {{ item.mobile }}</van-col>
                <van-col span="8">
                  状态:
                  <status-tag :status="item.status" :status_color="item.status_color" :status_text="item.status_text"></status-tag>
                </van-col>
                <van-col span="6">
                  等级:
                  <labels-tag :labels="item.labels" :labels_color="item.labels_color" :labels_text="item.labels_text"></labels-tag>
                </van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="24">置业顾问: {{ item.employee_text }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="24">约访时间: {{ item.log_time }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="24">跟进时间: {{ item.save_time }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="24">关键词: {{ item.keyword }}</van-col>
              </van-row>
              <van-row gutter="4" v-if="item.source_channel_v2_text">
                <van-col span="24">客户来源: <van-tag style="background-color: #c9c9c9">{{ item.source_channel_v2_text }}</van-tag></van-col>
              </van-row>
              <van-row gutter="4" v-if="item.total_budget_range_text">
                <van-col span="24">总价预算: <van-tag style="background-color: #c9c9c9">{{ item.total_budget_range_text }}</van-tag></van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="24">最新跟进: {{ item.log_content }}</van-col>
              </van-row>
              <van-row gutter="20" v-if="item.log_content !== item.best_log_content">
                <van-col span="24">最佳跟进: {{ item.best_log_content }}</van-col>
              </van-row>
              </span>
          </div>
        </van-cell-group>
    </van-list>
    <div v-if="finished" style="margin-top: 10px;margin-bottom: 10px;">
      <van-row>
        <van-col span="12" offset="9"><van-tag style="background-color: #c9c9c9">没有更多数据</van-tag></van-col>
      </van-row>
    </div>
    <!--扩展界面开始-->
    <div>
      <van-popup v-model="show" position="right" style="width:100%;height: 100%;overflow: auto">
        <div>
          <van-nav-bar
            title="客户详细信息"
            left-text="返回"
            right-text="跟进"
            left-arrow
            @click-left="onClickInfoLeft"
            @click-right="onClickInfoRight(info.id)"
            fix>
          </van-nav-bar>
        </div>

        <van-cell-group>
          <h2 class="van-doc-demo-block__title">基本信息</h2>
          <div class="van-panel__header van-hairline--bottom">
            <span class="van-panel__desc">
              <van-row gutter="4">
                <van-col span="24">姓名: {{ info.name }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12">电话: {{ info.mobile }}</van-col>
                <van-col span="7">
                  状态:
                  <status-tag :status="info.status" :status_color="info.status_color" :status_text="info.status_text"></status-tag>
                </van-col>
                <van-col span="5">
                  等级:
                  <labels-tag :labels="info.labels" :labels_color="info.labels_color" :labels_text="info.labels_text"></labels-tag>
                </van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="24">跟进时间: {{ info.save_time }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12">约访时间: {{ info.log_time }}</van-col>
                <van-col span="12">报备时间: {{ info.created_at }}</van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="12">来访时间: {{ info.come_time }}</van-col>
                <van-col span="12">成交时间: {{ info.success_time }}</van-col>
              </van-row>
              <van-row gutter="4">
                <van-col span="24">关键词: {{ info.keyword }}</van-col>
              </van-row>
              <van-row gutter="4" v-if="info.source_channel_v2_text">
                <van-col span="24">客户来源: <van-tag style="background-color: #c9c9c9">{{ info.source_channel_v2_text }}</van-tag></van-col>
              </van-row>
              <van-row gutter="4" v-if="info.total_budget_range_text">
                <van-col span="24">总价预算范围: <van-tag style="background-color: #c9c9c9">{{ info.total_budget_range_text }}</van-tag></van-col>
              </van-row>
              <van-row gutter="4" v-if="info.price_acceptance_level_text">
                <van-col span="24">单价接受程度: <van-tag style="background-color: #c9c9c9">{{ info.price_acceptance_level_text }}</van-tag></van-col>
              </van-row>
              <van-row gutter="4" v-if="info.purpose_v2_text">
                <van-col span="24">用途: <van-tag style="background-color: #c9c9c9">{{ info.purpose_v2_text }}</van-tag></van-col>
              </van-row>
              <van-row gutter="20">
                <van-col span="24">最新跟进: {{ info.log_content }}</van-col>
              </van-row>
              <van-row gutter="20" v-if="info.log_content !== info.best_log_content">
                <van-col span="24">最佳跟进: {{ info.best_log_content }}</van-col>
              </van-row>
            </span>
          </div>

          <h2 class="van-doc-demo-block__title">微信相关</h2>
          <div class="van-panel__header van-hairline--bottom">
            <span class="van-panel__desc">
              <van-row gutter="4">
                <van-col span="16">微信号: {{ info.wechat }}</van-col>
                <van-col span="8">是否添加: {{ info.wechat_status_text }}</van-col>
              </van-row>
              <van-row gutter="4">
                <van-col span="24">微信昵称: {{ info.wechat_nickname }}</van-col>
              </van-row>
              <van-row gutter="4">
                <van-col span="24">添加时间: {{ info.wechat_add_time }}</van-col>
              </van-row>
            </span>
          </div>
        </van-cell-group>

      </van-popup>
    </div>
  </div>
</template>

<script>
  import StatusTag from '../components/status-tag'
  import LabelsTag from '../components/labels-tag'
  import ListTag from '../components/list-tag'
    export default {
      components:{
        StatusTag,
        LabelsTag,
        ListTag,
      },
      data(){
        return{
          page:1,
          activeNames: [],
          list: this.$store.state.customer.state.list,
          loading: false,
          finished: false,
          show:false,

          info:[],
          subjects:[],
          logs:[],
          come:[],
          successes:[],

        }
      },
      watch: {
        '$route' (to, from) {
          this.show = false
          if (from.name === 'customer-search' && this.$store.state.search.isSearch) {//如果是从搜索页跳过来就主动刷新一下数据
            this.finished = false
            this.list = []
            this.$store.state.customer.state.list = [];
            this.page = 1
            this.$store.commit('changeRecruitScrollY', 0) //离开路由时把位置存起来
            let recruitScrollY = this.$store.state.recruitScrollY
            window.scroll(0, recruitScrollY)
            this.getCustomerList();
          }
        }
      },
      methods:{
        onClickInfoLeft(){
          this.show = false
        },
        onClickInfoRight(id) {
          //跳转跟进
          this.$router.push('customer/edit/'+id+'/customer');
        },
        onShow(id) {
          //获取客户信息
          this.$api.post('/api/customer/detail', {
            id: id,
          },cus => {
            this.show = true
            this.info = cus.info
            this.subjects = cus.subjects
            this.logs = cus.logs
            this.come = cus.come
            this.successes = cus.successes
          })
        },
        onLoad() {//上拉加载
          setTimeout(() => {
            this.getCustomerList();
          }, 500);
        },
        getCustomerList(){//获取客户列表数据
          this.loading = true;
          this.$api.post('/api/customer/list', {
            page:this.page,
            order:this.$store.state.search.searchOrder,
            start:this.$store.state.search.searchStartTime,
            end:this.$store.state.search.searchEndTime,
            keyword:this.$store.state.search.searchKeyword,
            status:this.$store.state.search.searchStatus,
            labels:this.$store.state.search.searchLabels,
            employees:this.$store.state.search.searchEmployees,
            total_budget_range:this.$store.state.search.searchTotalBudgetRange,
            price_acceptance_level:this.$store.state.search.searchPriceAcceptanceLevel,
            source_channel_v2:this.$store.state.search.searchSourceChannelV2,
            purpose_v2:this.$store.state.search.searchPurposeV2,
          }, data => {
            console.log(data)
            this.$store.state.customer.state.count = data.meta.pagination.total
            this.page++;
            for (let i = 0; i < data.data.length; i++) {
              this.$store.state.customer.state.list.push(data.data[i]);
            }
            this.list = this.$store.state.customer.state.list;
            this.loading = false;
            if (data.data.length < 20) {
              this.finished = true;
            }
          })
        }
      },
      created: function () {
        if(this.page == 1){
          this.list = []
          this.$store.state.customer.state.list = [];
        }
      }
    }
</script>

<style scoped>
  .pop_button{
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/list-customer.vue